import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const OdinPage = () => {
  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête avec titre */}
        <header style={styles.header}>
          <h1 style={styles.title}> 
            Evaluation de la couverture et de l'ouverture des données au Burundi par ODIN
          </h1>
          <div style={styles.metaInfo}>
            <span style={styles.date}>Résultats 2024</span>
            <span style={styles.location}>Inventaire des Données Ouvertes</span>
          </div>
        </header>

        {/* Section Résultats 2024 */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>01</span>
            Résultats ODIN 2024 pour le Burundi
          </h2>
          
          <p style={styles.paragraph}>
            Depuis le 29 avril 2025, les résultats de l'Inventaire des Données Ouvertes (ODIN) 2024 ont été 
            rendus publics par Open Data Watch. Selon ces résultats, le Burundi réalise des avancées 
            remarquables dans le classement mondial des données ouvertes comparativement à l'année 2022.
          </p>
          
          {/* Score global */}
          <div style={styles.scoreContainer}>
            <div style={styles.scoreCard}>
              <h3 style={styles.scoreTitle}>Score global 2024</h3>
              <div style={styles.scoreValue}>65,50/100</div>
              <div style={styles.scoreComparison}>
                <span style={styles.improvement}>+25,50 points</span> vs 2022 (40,00/100)
              </div>
            </div>
            
            <div style={styles.rankingCard}>
              <div style={styles.rankingItem}>
                <div style={styles.rankingLabel}>Classement Afrique</div>
                <div style={styles.rankingValue}>5ème</div>
                <div style={styles.rankingChange}>+24 places vs 2022</div>
              </div>
              
              <div style={styles.rankingItem}>
                <div style={styles.rankingLabel}>Classement Mondial</div>
                <div style={styles.rankingValue}>59ème</div>
                <div style={styles.rankingChange}>+77 places vs 2022</div>
              </div>
            </div>
          </div>
          
          <p style={styles.paragraph}>
            Cette performance est le fruit du travail régulier de mise à jour des données réalisée ces dernières 
            années par l'INSBU sur son site Web et le Portail des données ouvertes(ODP) ainsi que par l'ensemble des services 
            statistiques sectoriels du système statistique national afin de satisfaire la demande en données 
            des utilisateurs.
          </p>
          
          <div style={styles.linkBox}>
            <p style={styles.linkText}>
              <strong>Où trouver les résultats ODIN :</strong>{' '}
              <a href="https://odin.opendatawatch.com/" target="_blank" rel="noopener noreferrer" style={styles.link}>
                ODIN
              </a>
            </p>
          </div>
        </section>

        {/* Section Concepts clés */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>02</span>
            Concepts clés ODIN
          </h2>
          
          <div style={styles.conceptsGrid}>
            <div style={styles.conceptCard}>
              <div style={styles.conceptIcon}>📈</div>
              <h3 style={styles.conceptTitle}>Couverture</h3>
              <p style={styles.conceptText}>
                Fait référence à la disponibilité d'indicateurs statistiques importants dans 22 catégories 
                de statistiques sociales, économiques et environnementales.
              </p>
            </div>
            
            <div style={styles.conceptCard}>
              <div style={styles.conceptIcon}>🔓</div>
              <h3 style={styles.conceptTitle}>Ouverture</h3>
              <p style={styles.conceptText}>
                Les données et contenus ouverts peuvent être librement utilisés, modifiés et partagés par 
                toute personne, pour tout usage.
              </p>
            </div>
            
            <div style={styles.conceptCard}>
              <div style={styles.conceptIcon}>🎯</div>
              <h3 style={styles.conceptTitle}>Score global</h3>
              <p style={styles.conceptText}>
                Constitué un indice du niveau de complétude et d'ouverture des données fournies par un INS.
              </p>
            </div>
          </div>
        </section>
        {/* Section Couverture des données */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>03</span>
            Couverture des données
          </h2>
          
          <p style={styles.paragraph}>
            Le score de la couverture pour le Burundi s'établit en 2024 à <strong>51/100</strong> contre 
            <strong> 38/100</strong> en 2022, soit une progression de <strong>13 points</strong>.
          </p>
          
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statNumber}>15</div>
              <div style={styles.statLabel}>catégories avec score ≥ 50/100 en 2024</div>
              <div style={styles.statComparison}>(8 en 2022)</div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statNumber}>7</div>
              <div style={styles.statLabel}>catégories avec score  50/100 en 2024  </div>
              <div style={styles.statComparison}>(14 en 2022)</div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statNumber}>0</div>
              <div style={styles.statLabel}>catégories avec score nul en 2024</div>
              <div style={styles.statComparison}>(4 en 2022)</div>
            </div>
          </div>

          {/* Forces en couverture */}
          <div style={styles.strengthsSection}>
            <h3 style={styles.subtitle}>Forces du Burundi en couverture (zone verte) en 2024</h3>
            <div style={styles.categoryGrid}>
              {[
                {name: "Balance des Paiements", score: "100"},
                {name: "Monnaie et Banque", score: "83"},
                {name: "Établissements de santé", score: "80"},
                {name: "Indice des prix", score: "75"},
                {name: "Finances Publiques", score: "75"},
                {name: "Utilisation des ressources", score: "63"}
              ].map((category, index) => (
                <div key={index} style={styles.categoryCard}>
                  <div style={styles.categoryScore}>{category.score}</div>
                  <div style={styles.categoryName}>{category.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Faiblesses en couverture */}
          <div style={styles.weaknessesSection}>
            <h3 style={styles.subtitle}>Faiblesses du Burundi en couverture en 2024</h3>
            <div style={styles.categoryGrid}>
              {[
                {name: "Établissements d'enseignement", score: "40"},
                {name: "Comptes nationaux", score: "38"},
                {name: "Résultats pour la santé", score: "30"},
                {name: "Statistiques de genre", score: "30"},
                {name: "Environnement construit", score: "30"},
                {name: "Criminalité & justice", score: "30"},
                {name: "Sécurité alimentaire et nutrition", score: "25"}
              ].map((category, index) => (
                <div key={index} style={styles.categoryCardWeak}>
                  <div style={styles.categoryScoreWeak}>{category.score}</div>
                  <div style={styles.categoryName}>{category.name}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section Ouverture des données */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>04</span>
            Ouverture des données
          </h2>
          
          <p style={styles.paragraph}>
            Le score d'ouverture du Burundi s'établit en 2024 à <strong>77/100</strong> contre 
            <strong> 42/100</strong> en 2022, soit une progression remarquable de <strong>35 points</strong>.
          </p>

          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statNumber}>21</div>
              <div style={styles.statLabel}>catégories avec score ≥ 60/100 en 2024</div>
              <div style={styles.statComparison}>(8 en 2022)</div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statNumber}>14</div>
              <div style={styles.statLabel}>catégories avec score ≥ 70/100 en 2024</div>
              <div style={styles.statComparison}>(2 en 2022)</div>
            </div>
            
            <div style={styles.statCard}>
              <div style={styles.statNumber}>1</div>
              <div style={styles.statLabel}>seule catégorie avec score faible en 2024</div>
              <div style={styles.statComparison}>(14 en 2022)</div>
            </div>
          </div>

          {/* Forces en ouverture */}
          <div style={styles.strengthsSection}>
            <h3 style={styles.subtitle}>Forces du Burundi en ouverture (zone verte) en 2024</h3>
            <div style={styles.categoryGrid}>
              {[
                {name: "Sécurité alimentaire et nutrition", score: "100"},
                {name: "Main d'œuvre", score: "90"},
                {name: "Indice des prix", score: "90"},
                {name: "Finances Publiques", score: "90"},
                {name: "Commerce extérieur", score: "90"},
                {name: "Agriculture et utilisation des terres", score: "90"},
                {name: "Énergie", score: "90"},
                {name: "Pollution", score: "90"},
                {name: "Établissements d'enseignement", score: "80"},
                {name: "Résultats pour la santé", score: "80"},
                {name: "Monnaie et Banque", score: "80"},
                {name: "Utilisation des ressources", score: "80"},
                {name: "Environnement construit", score: "80"},
                {name: "Statistiques de genre", score: "70"}
              ].map((category, index) => (
                <div key={index} style={styles.categoryCard}>
                  <div style={styles.categoryScore}>{category.score}</div>
                  <div style={styles.categoryName}>{category.name}</div>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Section indicateurs manquants */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>05</span>
            Indicateurs à améliorer
          </h2>
          
          <p style={styles.paragraph}>
            Voici la liste des indicateurs non renseignés qui affectent le score de couverture :
          </p>
          
          <div style={styles.indicatorsGrid}>
            <div style={styles.indicatorColumn}>
              <h4 style={styles.indicatorTitle}>Indicateurs manquants</h4>
              <ul style={styles.indicatorList}>
                <li>Naissances</li>
                <li>Décès</li>
                <li>Dépenses d'éducation</li>
                <li>Lits d'hôpital</li>
                <li>Mortalité infantile</li>
                <li>Insécurité alimentaire</li>
                <li>Homicides</li>
                <li>Produit intérieur brut</li>
                <li>Répartition de l'emploi</li>
                <li>Transferts de fonds</li>
                <li>Exploitation forestière</li>
                <li>Pollution de l'eau</li>
                <li>Surpeuplement</li>
                <li>Durabilité des logements</li>
              </ul>
            </div>
            
            <div style={styles.indicatorColumn}>
              <h4 style={styles.indicatorTitle}>Scores de désagrégation</h4>
              <div style={styles.disaggregationScores}>
                <div style={styles.scoreItem}>
                  <span style={styles.scoreLabel}>Par commune :</span>
                  <span style={styles.scoreValue}>10/100</span>
                </div>
                <div style={styles.scoreItem}>
                  <span style={styles.scoreLabel}>Par province :</span>
                  <span style={styles.scoreValue}>25/100</span>
                </div>
                <div style={styles.scoreItem}>
                  <span style={styles.scoreLabel}>Sur 10 ans :</span>
                  <span style={styles.scoreValue}>51/100</span>
                </div>
                <div style={styles.scoreItem}>
                  <span style={styles.scoreLabel}>Sur 5 ans :</span>
                  <span style={styles.scoreValue}>59/100</span>
                </div>
                <div style={styles.scoreItem}>
                  <span style={styles.scoreLabel}>Indicateur disponible :</span>
                  <span style={styles.scoreValue}>84/100</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '25px',
    borderBottom: `2px solid #008D36`,
  },
  title: {
    color: '#008D36',
    fontSize: '2rem',
    marginBottom: '15px',
    fontWeight: '600',
    lineHeight: 1.2,
  },
  metaInfo: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    color: '#666',
    fontSize: '1.1rem',
  },
  date: {
    padding: '5px 15px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
  },
  location: {
    padding: '5px 15px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
  },
  section: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
  },
  sectionNumber: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '5px 15px',
    borderRadius: '4px',
    marginRight: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  paragraph: {
    marginBottom: '25px',
    textAlign: 'justify',
    fontSize: '1.1rem',
    lineHeight: 1.8,
    color: '#333',
  },
  conceptsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '25px',
    marginTop: '30px',
  },
  conceptCard: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
    borderTop: `4px solid #008D36`,
  },
  conceptIcon: {
    fontSize: '2.5rem',
    marginBottom: '15px',
  },
  conceptTitle: {
    color: '#008D36',
    fontSize: '1.3rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  conceptText: {
    color: '#666',
    lineHeight: 1.6,
  },
  scoreContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    margin: '40px 0',
  },
  scoreCard: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '30px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  scoreTitle: {
    fontSize: '1.3rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  scoreValue: {
    fontSize: '3.5rem',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  scoreComparison: {
    fontSize: '1.1rem',
    opacity: 0.9,
  },
  improvement: {
    fontWeight: 'bold',
    color: '#FFD700',
  },
  rankingCard: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
  },
  rankingItem: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
    border: `2px solid #008D36`,
  },
  rankingLabel: {
    color: '#666',
    fontSize: '1rem',
    marginBottom: '10px',
  },
  rankingValue: {
    color: '#008D36',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  rankingChange: {
    color: '#E30613',
    fontSize: '0.9rem',
    fontWeight: '600',
  },
  linkBox: {
    backgroundColor: '#f0f0f0',
    padding: '20px',
    borderRadius: '8px',
    marginTop: '30px',
  },
  linkText: {
    margin: 0,
    fontSize: '1.1rem',
  },
  link: {
    color: '#008D36',
    textDecoration: 'none',
    fontWeight: '600',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    margin: '30px 0',
  },
  statCard: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
    border: `1px solid #ddd`,
  },
  statNumber: {
    color: '#008D36',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  statLabel: {
    color: '#333',
    fontSize: '1rem',
    marginBottom: '5px',
    lineHeight: 1.4,
  },
  statComparison: {
    color: '#666',
    fontSize: '0.9rem',
    fontStyle: 'italic',
  },
  strengthsSection: {
    margin: '40px 0',
    padding: '25px',
    backgroundColor: '#f0f9f0',
    borderRadius: '8px',
    borderLeft: `4px solid #008D36`,
  },
  weaknessesSection: {
    margin: '40px 0',
    padding: '25px',
    backgroundColor: '#fff0f0',
    borderRadius: '8px',
    borderLeft: `4px solid #E30613`,
  },
  subtitle: {
    color: '#333',
    fontSize: '1.5rem',
    marginBottom: '25px',
    fontWeight: '600',
  },
  categoryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '15px',
  },
  categoryCard: {
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
  },
  categoryCardWeak: {
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
    borderLeft: `3px solid #E30613`,
  },
  categoryScore: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '4px',
    marginRight: '15px',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    minWidth: '50px',
    textAlign: 'center',
  },
  categoryScoreWeak: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '4px',
    marginRight: '15px',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    minWidth: '50px',
    textAlign: 'center',
  },
  categoryName: {
    color: '#333',
    fontSize: '0.95rem',
    flex: 1,
  },
  singleWeakness: {
    display: 'flex',
    justifyContent: 'center',
  },
  weaknessCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
    border: `2px solid #E30613`,
    maxWidth: '300px',
  },
  weaknessScore: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '10px 15px',
    borderRadius: '4px',
    marginRight: '20px',
    fontWeight: 'bold',
    fontSize: '1.3rem',
    minWidth: '60px',
    textAlign: 'center',
  },
  weaknessName: {
    color: '#333',
    fontSize: '1.1rem',
    fontWeight: '600',
  },
  recommendationsSection: {
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    marginBottom: '40px',
    borderTop: `4px solid #008D36`,
  },
  recommendationsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '30px',
    marginTop: '30px',
  },
  recommendationCard: {
    backgroundColor: '#f9f9f9',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 3px 10px rgba(0,0,0,0.05)',
  },
  recommendationIcon: {
    fontSize: '2.5rem',
    marginBottom: '20px',
    textAlign: 'center',
  },
  recommendationTitle: {
    color: '#008D36',
    fontSize: '1.4rem',
    marginBottom: '20px',
    textAlign: 'center',
    fontWeight: '600',
  },
  recommendationList: {
    listStyleType: 'none',
    padding: 0,
  },
  indicatorsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px',
    marginTop: '20px',
  },
  indicatorColumn: {
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
  },
  indicatorTitle: {
    color: '#008D36',
    fontSize: '1.2rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  indicatorList: {
    listStyleType: 'none',
    padding: 0,
  },
  disaggregationScores: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  scoreItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  scoreLabel: {
    color: '#666',
  },
  scoreValue: {
    color: '#008D36',
    fontWeight: '600',
  },
};

export default OdinPage;